module.exports = __webpack_public_path__ + "images/places/training_634-e72758577ede5695f13da17657464d10.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_634.jpg
 ** module id = 316
 ** module chunks = 0
 **/